module.exports = __webpack_public_path__ + "img/JLTP_fraction_N4N5.c1062669.svg";